// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"26":"font-awesome","434":"chunk-ckeditor","547":"bootstrap","881":"jquery"}[chunkId] || chunkId) + "." + {"26":"24151c6904273f58b2b5","434":"d376b4149b33865e1a1d","547":"9d531b868cc2ef183d83","668":"2746d58420976a3aeeda","881":"53274e0860c7cb9f8731"}[chunkId] + ".js";
};